<template>

  <van-popup v-model="_value" position="bottom">
    <van-picker
            title="安装员"
            show-toolbar
            :columns="installerIdOptions"
            @confirm="onConfirminstallerId"
            @cancel="onCancelinstallerId"
    />
  </van-popup>

</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  import {
    Cell,
    CellGroup,
    Field,
    Row,
    Col,
    Button,
    Dialog,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Picker,
    Popup,
    Divider,
    Collapse,
    CollapseItem,
    DatetimePicker,
    Tag,
    DropdownMenu,
    DropdownItem,
    Sticky,
    Icon,
    Search,
    PullRefresh,
    List,
    Loading,
    Toast,
    Uploader,
    Overlay,
    NumberKeyboard,
    Tab, Tabs
  } from 'vant'

  Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Tab).use(Tabs)
          .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay).use(NumberKeyboard)
          .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

  export default {
    name: 'changeinstallermodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        installers:[],
        installOrder: {
          id:null,
          installerId:null
        },

        /**
         * 选择安装员
         */
        installerId:'',
        _value: false,
        installerIdOptions: [],
      }
    },
    methods: {
      ...mapActions([
        'InstallOrderServ_ChangeInstaller',
        'UserServ_GetAllUsers',
        'InstallOrderServ_GetDetail'
      ]),
      onConfirminstallerId(value, index) {
        this.installerId = value
        store.dispatch('UserServ_GetPage', {
          params: null,
          urlparams: {keyword: this.installerId}
        }).then(res => {
          console.log(res)
          if (store.getters.get_User_GetPageResult.content) {
            this.installOrder.installerId = store.getters.get_User_GetPageResult.content[0].id
            this.installOrder.id = this._initValue

            store.dispatch('InstallOrderServ_ChangeInstaller', {params: this.installOrder}).then(() => {
              this.$Message.success('指派安装员成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })

          }
        }).catch(err => {
        })
        this._value = false
      },
      onCancelinstallerId() {
        this._value = false
      },
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.installerIdOptions = []
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8,14] }
        }).then(() => {
          if (store.getters.get_User_GetAllUsersResult) {
            store.getters.get_User_GetAllUsersResult.forEach(item => {
              this.installerIdOptions.push(item.realName!=null?item.realName:item.name!=null?item.name:item.nickName)
            })
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      })
    }
  }
</script>
